<template>
  <v-container grid-list-xl>
    <v-card>
      <v-toolbar flat color="indigo lighten-5">
        <v-icon left color="indigo darken-2">verified_user</v-icon>
        <v-toolbar-title class="font-weight-bold indigo--text text--darken-2">Sigorta Bedelleri</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip color="indigo darken-2" text-color="white" small label>{{ filteredItems.length }} sipariş</v-chip>
      </v-toolbar>

      <v-layout wrap class="px-3 pt-3">
        <v-flex xs12 sm4 class="px-2">
          <v-card outlined class="pa-3 if-total if-total-red">
            <div class="if-total-label">Toplam Ödenecek Bedel</div>
            <div class="if-total-value red--text text--darken-2">- {{ formatMoney(summary.totalPayable) }} ₺</div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 class="px-2">
          <v-card outlined class="pa-3 if-total if-total-green">
            <div class="if-total-label">Toplam Alınacak (Kayıp Tazminatları)</div>
            <div class="if-total-value green--text text--darken-2">+ {{ formatMoney(summary.totalReceivable) }} ₺</div>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 class="px-2">
          <v-card outlined class="pa-3 if-total">
            <div class="if-total-label">Net (Alınacak − Ödenecek)</div>
            <div class="if-total-value" :class="summary.net >= 0 ? 'green--text text--darken-2' : 'red--text text--darken-2'">
              {{ summary.net >= 0 ? '+' : '-' }} {{ formatMoney(Math.abs(summary.net)) }} ₺
            </div>
          </v-card>
        </v-flex>
      </v-layout>

      <div v-if="summary.settingsMissing" class="px-4 pt-1">
        <v-alert :value="true" type="warning" outline class="ma-0">
          Sigorta paket sabiti / çarpanı henüz girilmemiş. Ayarlar ekranından girin.
        </v-alert>
      </div>

      <v-layout wrap align-center class="px-3 pt-2">
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="startDate" label="Başlangıç (Tamamlanma)" prepend-icon="event" readonly v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="startDate" locale="tr-TR" @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDate" label="Bitiş (Tamamlanma)" prepend-icon="event" readonly v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="endDate" locale="tr-TR" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm2 class="px-2">
          <v-checkbox v-model="onlyLost" label="Sadece Kayıplar" hide-details @change="load"></v-checkbox>
        </v-flex>
        <v-flex xs12 sm2 class="px-2">
          <v-text-field v-model="search" label="Ara (sipariş no / müşteri)" prepend-icon="search" clearable hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 sm2 class="px-2">
          <v-btn color="indigo darken-2" dark :loading="loading" @click="load">
            <v-icon left>filter_list</v-icon>Listele
          </v-btn>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers" :items="filteredItems" :loading="loading" :rows-per-page-items="[25, 50, 100, { text: 'Tümü', value: -1 }]" class="elevation-0 mt-2">
        <template v-slot:items="props">
          <td class="px-2">{{ formatDate(props.item.completedDate) }}</td>
          <td class="px-2">{{ props.item.orderNumber }}</td>
          <td class="px-2">{{ props.item.recipientName }}</td>
          <td class="px-2">{{ props.item.shippingCity }}</td>
          <td class="px-2 text-xs-right">{{ formatMoney(props.item.totalAmount) }} ₺</td>
          <td class="px-2 text-xs-right red--text text--darken-2 font-weight-bold">- {{ formatMoney(props.item.premium) }} ₺</td>
          <td class="px-2 text-xs-right">
            <span v-if="props.item.isLost" class="green--text text--darken-2 font-weight-bold">+ {{ formatMoney(props.item.claim) }} ₺</span>
            <span v-else class="grey--text">-</span>
          </td>
          <td class="px-2 text-xs-center">
            <v-chip v-if="props.item.isLost" small color="deep-orange darken-1" text-color="white">Kayıp</v-chip>
            <span v-else class="grey--text">-</span>
          </td>
        </template>
        <template v-slot:no-data>
          <div class="pa-4 text-xs-center grey--text">{{ loading ? 'Yükleniyor...' : 'Seçili aralıkta kayıt yok.' }}</div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { authenticationService } from "@/_services";

export default {
  data() {
    return {
      loading: false,
      menu1: false,
      menu2: false,
      startDate: null,
      endDate: null,
      onlyLost: false,
      search: '',
      tenantId: null,
      mpId: null,
      summary: { totalPayable: 0, totalReceivable: 0, net: 0, settingsMissing: false, items: [] },
    };
  },
  computed: {
    headers() {
      return [
        { text: 'Tamamlanma Tarihi', value: 'completedDate', sortable: true },
        { text: 'Sipariş No', value: 'orderNumber', sortable: false },
        { text: 'Müşteri', value: 'recipientName', sortable: false },
        { text: 'Şehir', value: 'shippingCity', sortable: false },
        { text: 'Sipariş Tutarı', value: 'totalAmount', sortable: false, align: 'right' },
        { text: 'Prim (Ödenecek)', value: 'premium', sortable: false, align: 'right' },
        { text: 'Tazminat (Alınacak)', value: 'claim', sortable: false, align: 'right' },
        { text: 'Durum', value: 'isLost', sortable: false, align: 'center' },
      ];
    },
    filteredItems() {
      const q = (this.search || '').trim().toLocaleLowerCase('tr');
      const items = this.summary.items || [];
      if (!q) return items;
      return items.filter((o) =>
        (o.orderNumber || '').toLocaleLowerCase('tr').includes(q) ||
        (o.recipientName || '').toLocaleLowerCase('tr').includes(q));
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.summary = (await this.$store.dispatch('orders/getInsuranceFees', {
          startDate: this.startDate,
          endDate: this.endDate,
          onlyLost: this.onlyLost,
        })) || { totalPayable: 0, totalReceivable: 0, net: 0, settingsMissing: false, items: [] };
      } catch (e) {
        this.summary = { totalPayable: 0, totalReceivable: 0, net: 0, settingsMissing: false, items: [] };
      } finally {
        this.loading = false;
      }
    },
    formatDate(value) {
      if (!value) return '';
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString('tr-TR');
    },
    formatMoney(value) {
      return (Number(value) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  async mounted() {
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');
    const currentUser = authenticationService.currentUserValue;
    this.tenantId = selectedTenant || (currentUser && currentUser.tenantId) || localStorage.getItem('tenantId');
    this.mpId = selectedMp || (currentUser && currentUser.mpId);

    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);
    this.startDate = past.toISOString().substr(0, 10);
    this.endDate = today.toISOString().substr(0, 10);

    await this.load();
  },
};
</script>

<style scoped>
.if-total {
  border-radius: 12px;
}
.if-total-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  margin-bottom: 4px;
}
.if-total-value {
  font-size: 22px;
  font-weight: 800;
}
.if-total-red {
  background: #fef2f2;
}
.if-total-green {
  background: #f0fdf4;
}
</style>
